<template>
  <diV>
    <v-row>
      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Ticket Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="GetTicketTypes"
            label="Ticket Type"
            name="Ticket Type"
            outlined
            placeholder="Please select Ticket Type"
            v-model="ticket.ticketType"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="ticket.ticketType !== 'Service Request'"
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Technology Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="GetTechnologyTypes"
            label="Technology Type"
            name="Technology Type"
            outlined
            placeholder="Please select Technology Type"
            v-model="ticket.technologyType"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Category"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="CategoryOptions"
            label="Category"
            name="Category"
            outlined
            placeholder="Please select Category"
            v-model="ticket.category"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Severity"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="Severities"
            label="Severity"
            name="Severity"
            outlined
            placeholder="Please select Severity"
            v-model="ticket.severity"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1">
        <ValidationProvider
          name="Description"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.description"
            label="Description"
            placeholder=" "
            outlined
            dense
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        v-if="ticket.ticketType == 'Service Request' && ticket.category != 'FNN/ULL Dispute' && ticket.category != 'Technology Enquiry'"
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="SubCategory"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="SubCategoryOptions"
            label="SubCategory"
            name="SubCategory"
            outlined
            placeholder="Please select Sub Category"
            v-model="ticket.subCategory"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col cols="12" :md="6" class="pt-0 pb-1">
        <ValidationProvider
          name="Reference ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.externalId"
            label="Reference ID"
            placeholder=" "
            outlined
            dense
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col
        cols="12"
        :md="6"
        class="pt-0 pb-1"
        v-if="ticket.ticketType !== 'Service Request' && (ticket.technologyType == 'FTTB' ||ticket.technologyType == 'FTTN')"
      >
        <ValidationProvider
          name="Fault Location"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="FaultLocations"
            label="Fault Location"
            name="Fault Location"
            outlined
            placeholder="Please select Fault Location"
            v-model="ticket.faultLocation"
          ></v-select>
        </ValidationProvider>
      </v-col>


      <v-col v-if="ticket.ticketType != 'Service Request' && (ticket.technologyType == 'FTTC' || ticket.faultLocation =='Appointment')" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Appointment ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.appointmentId"
            label="Appointment ID"
            placeholder="Please select appointment"
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.category == 'API Gateway fault' || ticket.category == 'CV&T fault' || ticket.category == 'NBN Co Service Portal fault'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Error Code"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.errorCode"
            label="Error Code"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.category == 'API Gateway fault' || ticket.category == 'CV&T fault' || ticket.category == 'NBN Co Service Portal fault'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Error Reason"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.errorReason"
            label="Error Reason"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.ticketType != 'Service Restoration' &&(ticket.category == 'Orders' || ticket.category == 'Service Transfer' || ticket.category == 'Transition Reversal' || ticket.category == 'Voiceband Reinstatement')" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Order ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.orderId"
            label="Order ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col  v-if="ticket.ticketType != 'Service Restoration' && (ticket.category == 'Equipment' && ticket.subCategory != 'BTD Redundant Power Supply' || ticket.category == 'Orders' || ticket.category == 'Service Transfer' || ticket.category == 'Technology Enquiry' || ticket.category == 'Voiceband Reinstatement' || ticket.category == 'FNN/ULL Dispute' || ticket.subCategory == 'Incorrect Service Class returned')" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Location ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.locationId"
            label="Location ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col  v-if="ticket.ticketType != 'Service Restoration' && (ticket.category == 'Equipment' && ticket.subCategory == 'BTD Redundant Power Supply' || ticket.category == 'Service Profile' || ticket.category == 'Transition Reversal' || ticket.category == 'Voiceband Reinstatement')" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Product ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.productId"
            label="Product ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col v-if="ticket.category == 'FNN/ULL Dispute'" cols="12" md="12" lg="12" class="pb-0">
        <v-radio-group
          row
          v-model="ticket.fnnUll"
        >
          <label class="mr-2">Fnn or ULL</label>
          <v-radio label="Fnn" value="Fnn"></v-radio>
          <v-radio label="Ull" value="Ull"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col  v-if="ticket.category == 'FNN/ULL Dispute' || ticket.category == 'Transition Reversal' || ticket.category == 'Voiceband Reinstatement'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="FNN/ULL ID"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.fnnUllId"
            label="FNN/ULL ID"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col  v-if="ticket.category == 'Transition Reversal' || ticket.category == 'Voiceband Reinstatement'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Reason for request"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.reasonRequest"
            label="Reason for request"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col  v-if="ticket.ticketType == 'Service Request' && ticket.category == 'Address' && ticket.subCategory == 'Incorrect Service Class returned'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Returned Service Class"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.returnedSc"
            label="Returned Service Class"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col  v-if="ticket.ticketType == 'Service Request' && ticket.category == 'Address' && ticket.subCategory == 'Incorrect Service Class returned'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Expected Service Class"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.expectedSc"
            label="Expected Service Class"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.subCategory == 'Missing address' || ticket.category == 'Technology Enquiry'"
        cols="12"
        :md="6"
        class="pt-0 pb-1"
      >
        <ValidationProvider
          name="State"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="States"
            label="State"
            name="State"
            outlined
            placeholder="Please select State"
            v-model="ticket.state"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.subCategory == 'Missing address'|| ticket.category == 'Technology Enquiry'"
             cols="12"
             :md="6"
             class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Suburb"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.suburb"
            label="Suburb"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.subCategory == 'Missing address'|| ticket.category == 'Technology Enquiry'"
             cols="12"
             :md="6"
             class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Street Name"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.streetName"
            label="Street Name"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.subCategory == 'Missing address'|| ticket.category == 'Technology Enquiry'"
             cols="12"
             :md="6"
             class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Street Type"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-select
            :items="StreetTypes"
            label="Street Type"
            name="Street Type"
            outlined
            placeholder="Please select Street Type"
            v-model="ticket.streetType"
          ></v-select>
        </ValidationProvider>
      </v-col>

      <v-col v-if="ticket.subCategory == 'Missing address'|| ticket.category == 'Technology Enquiry'"
             cols="12"
             :md="6"
             class="pt-0 pb-1"
      >
        <ValidationProvider
          name="Street Number"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.streetNumber"
            label="Street Number"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col v-if="ticket.ticketType == 'Service Request' && ticket.category == 'Potential Network Fault Investigation'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Contact: Technician Given Name"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.contactGivenName"
            label="Contact: Technician Given Name"
            placeholder="Please provide Contact: Technician Given Name"
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col v-if="ticket.ticketType == 'Service Request' && ticket.category == 'Potential Network Fault Investigation'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Contact: Technician Family Name"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.contactFamilyName"
            label="Contact: Technician Family Name"
            placeholder="Please provide Contact: Technician Family Name"
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col v-if="ticket.ticketType == 'Service Request' && ticket.category == 'Potential Network Fault Investigation'" cols="12" :md="'6'" class="pt-0 pb-1">
        <ValidationProvider
          name="Contact: Technician Number"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            v-model="ticket.contactNumber"
            label="Contact: Technician Number"
            placeholder="Please provide Contact: Technician Number"
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
    </v-row>
    <nbn-check-list-details v-if="ticket.ticketType == 'Service Restoration'" :ticket="ticket"></nbn-check-list-details>
  </diV>
</template>

<script>
export default {
  name: "nbn-ticket-details",
  props: {
    ticket: { type: Object },
    fromOrderView: { type: Boolean, required: true },
    technologyType: { type: String, required: false },
  },
  data: () => ({
    Categories: [
    ],
    SubCategories: [
      {text: "Standard", value: "Standard", disabled: false},
      {text: "Accelerated", value: "Accelerated", disabled: false},
    ],
    Severities: [
      {text: "Critical", value: "Critical", disabled: false},
      {text: "High", value: "High", disabled: false},
      {text: "Medium", value: "Medium", disabled: false},
      {text: "Low", value: "Low", disabled: false},
    ],
    Technologies:[
      {text: "Fibre", value: "Fibre", disabled: false},
      {text: "Fixed Wireless", value: "Fixed Wireless", disabled: false},
      {text: "HFC", value: "HFC", disabled: false},
      {text: "FTTC", value: "FTTC", disabled: false},
      {text: "FTTN", value: "FTTN", disabled: false},
      {text: "FTTB", value: "FTTB", disabled: false},
    ],
    FaultLocations:[
      {text: "Inside End User's Premises", value: "Appointment", disabled: false},
      {text: "Outside End User's Premises", value: "Commitment", disabled: false},
    ]
  }),
  computed: {
    GetTechnologyTypes() {
      let vm = this;
      if(vm.fromOrderView)
      {
        return [
          {text: vm.technologyType, value: vm.technologyType, disabled: false},
        ]
      } else {
        return vm.Technologies;
      }
    },
    GetTicketTypes() {
      let vm = this;
      if(vm.fromOrderView)
      {
        return [
          {text: "Service Restoration", value: "Service Restoration", disabled: false},
        ];
      } else {
        return [
          {text: "Service Request", value: "Service Request", disabled: false},
          {text: "Service Restoration", value: "Service Restoration", disabled: false},
        ];
      }
    },
    CategoryOptions(){
      let vm = this;
      let categories = [];
      if(vm.ticket.ticketType == 'Service Request')
      {
        categories = [
          {text: "Address", value: "Address", disabled: false},
          {text: "API Gateway fault", value: "API Gateway fault", disabled: false},
          {text: "Customer Centre fault", value: "Customer Centre fault", disabled: false},
          {text: "CV&T fault", value: "CV&T fault", disabled: false},
          {text: "Downstream Access Seeker Details", value: "Downstream Access Seeker Details", disabled: false},
          {text: "Developer Portal fault", value: "Developer Portal fault", disabled: false},
          {text: "Equipment", value: "Equipment", disabled: false},
          {text: "Facilities Access", value: "Facilities Access", disabled: false},
          {text: "FNN/ULL Dispute", value: "FNN/ULL Dispute", disabled: false},
          {text: "NBN Co Service Portal fault", value: "NBN Co Service Portal fault", disabled: false},
          {text: "Orders", value: "Orders", disabled: false},
          {text: "Potential Network Fault Investigation", value: "Potential Network Fault Investigation", disabled: false},
          {text: "Problem Management Investigation", value: "Problem Management Investigation", disabled: false},
          {text: "Reporting Fault", value: "Reporting Fault", disabled: false},
          {text: "Service Profile", value: "Service Profile", disabled: false},
          {text: "Service Transfer", value: "Service Transfer", disabled: false},
          {text: "Technology Enquiry", value: "Technology Enquiry", disabled: false},
          {text: "Transition Reversal", value: "Transition Reversal", disabled: false},
          {text: "Voiceband Reinstatement", value: "Voiceband Reinstatement", disabled: false},
          {text: "VDSL2 equipment registration", value: "VDSL2 equipment registration", disabled: false},
          {text: "End User Administration Portal error (EUAP)", value: "End User Administration Portal error (EUAP)", disabled: false},
          {text: "Other", value: "Other", disabled: false},
        ];
      } else if(vm.ticket.ticketType == 'Service Restoration')
      {
        if(vm.ticket.technologyType != null)
        {
          if(vm.ticket.technologyType == 'FTTC')
          {
            categories = [
              {text: "Dropout", value: "Dropout", disabled: false},
              {text: "No Data", value: "No Data", disabled: false},
              {text: "Speed", value: "Speed", disabled: false},
              {text: "Voice", value: "Voice", disabled: false},
              {text: "Dispute - Potential Performance Incident", value: "Dispute - Potential Performance Incident", disabled: false},
              {text: "Dispute - Potential Service Fault", value: "Dispute - Potential Service Fault", disabled: false},
            ];
          } else if(vm.ticket.technologyType == 'FTTB' || vm.ticket.technologyType == 'FTTN')
          {
            categories = [
              {text: "Intermittent service/dropouts", value: "Intermittent service/dropouts", disabled: false},
              {text: "New service never worked", value: "New service never worked", disabled: false},
              {text: "No data connection", value: "No data connection", disabled: false},
              {text: "No sync", value: "No sync", disabled: false},
              {text: "Performance latency", value: "Performance latency", disabled: false},
              {text: "VOIP fault", value: "VOIP fault", disabled: false},
              {text: "Other", value: "Other", disabled: false},
            ];
            if(vm.ticket.technologyType == 'FTTN')
            {
              categories.push({text: "Dispute - Potential Performance Incident", value: "Dispute - Potential Performance Incident", disabled: false});
              categories.push({text: "Dispute - Potential Service Fault", value: "Dispute - Potential Service Fault", disabled: false});
            }
          } else if(vm.ticket.technologyType == 'HFC')
          {
            categories = [
              {text: "New service never worked", value: "New service never worked", disabled: false},
              {text: "Service degradation - Intermittent Speed", value: "Service degradation - Intermittent Speed", disabled: false},
              {text: "Service degradation - Slow Speed", value: "Service degradation - Slow Speed", disabled: false},
              {text: "Service Loss", value: "Service Loss", disabled: false},
              {text: "Equipment Swap/Upgrade Required", value: "Equipment Swap/Upgrade Required", disabled: false},
              {text: "Dispute - Potential Performance Incident", value: "Dispute - Potential Performance Incident", disabled: false},
              {text: "Dispute - Potential Service Fault", value: "Dispute - Potential Service Fault", disabled: false},
            ];
          } else if(vm.ticket.technologyType == 'Fibre' || vm.ticket.technologyType == 'Fixed Wireless')
          {
            categories = [
              {text: "Intermittent service/dropouts", value: "Intermittent service/dropouts", disabled: false},
              {text: "New service never worked", value: "New service never worked", disabled: false},
              {text: "No auth/packet lost", value: "No auth/packet lost", disabled: false},
              {text: "No data connection/red optical", value: "No data connection/red optical", disabled: false},
              {text: "Performance latency", value: "Performance latency", disabled: false},
              {text: "Other", value: "Other", disabled: false}
            ];
          }
        }
      }
      return categories;
    },
    SubCategoryOptions() {
      let vm = this;
      let subCategories = [];
      if(vm.ticket.ticketType == 'Service Request' && vm.ticket.category != null) {
        switch (vm.ticket.category) {
          case "Address":
            subCategories = [
              {text: "Incorrect Service Class returned", value: "Incorrect Service Class returned", disabled: false},
              {text: "Missing address", value: "Missing address", disabled: false},
            ];
            break;
          case "API Gateway fault":
            subCategories = [
              {text: "Address API error", value: "Address API error", disabled: false},
              {text: "Appointment API error", value: "Appointment API error", disabled: false},
              {text: "Billing API error", value: "Billing API error", disabled: false},
              {text: "Change API error", value: "Change API error", disabled: false},
              {text: "Diagnostics API error", value: "Diagnostics API error", disabled: false},
              {
                text: "Fixed Wireless Network Performance API error",
                value: "Fixed Wireless Network Performance API error",
                disabled: false
              },
              {text: "Party API error", value: "Party API error", disabled: false},
              {text: "Product Inventory API error", value: "Product Inventory API error", disabled: false},
              {text: "Product Order API error", value: "Product Order API error", disabled: false},
              {text: "Product Qualification API error", value: "Product Qualification API error", disabled: false},
              {text: "Service Health API error", value: "Service Health API error", disabled: false},
              {text: "Service Qualification API error", value: "Service Qualification API error", disabled: false},
              {text: "Subscription API error", value: "Subscription API error", disabled: false},
              {text: "Trouble Ticket API error", value: "Trouble Ticket API error", disabled: false},
              {text: "Capacity API error", value: "Capacity API error", disabled: false},
              {text: "Document Management API error", value: "Document Management API error", disabled: false},
              {text: "Media API error", value: "Media API error", disabled: false},
              {text: "Quote API error", value: "Quote API error", disabled: false},
              {text: "Resource Planning API error", value: "Resource Planning API error", disabled: false},
              {text: "Sales API error", value: "Sales API error", disabled: false},
              {text: "Service Levels API error", value: "Service Levels API error", disabled: false},
            ];
            break;
          case "Customer Centre fault":
            subCategories = [
              {text: "Operational Reporting", value: "Operational Reporting", disabled: false},
              {text: "Other", value: "Other", disabled: false},
            ];
            break;
          case "CV&T fault":
            subCategories = [
              {text: "CV&T unavailable", value: "CV&T unavailable", disabled: false},
              {text: "Not receiving notifications (subscriptions)", value: "Not receiving notifications (subscriptions)", disabled: false},
              {text: "CV&T error", value: "CV&T error", disabled: false},
            ];
            break;
          case "Downstream Access Seeker Details":
            subCategories = [
              {text: "NAS to DAS Linkage", value: "NAS to DAS Linkage", disabled: false},
            ];
            break;
          case "Developer Portal fault":
            subCategories = [
              {text: "Content Issue", value: "Content Issue", disabled: false},
              {text: "CV&T Credentials Issue", value: "CV&T Credentials Issue", disabled: false},
              {text: "Production Credentials Issue", value: "Production Credentials Issue", disabled: false},
              {text: "Notifications Callback Issue", value: "Notifications Callback Issue", disabled: false},
              {text: "Certification Issue", value: "Certification Issue", disabled: false},
              {text: "Developer Portal Unavailable / Page Timeout", value: "Developer Portal Unavailable / Page Timeout", disabled: false},
            ];
            break;
          case "Equipment":
            subCategories = [
              {text: "Battery Backup / PSU Issue", value: "Battery Backup / PSU Issue", disabled: false},
              {text: "NTD Issue", value: "NTD Issue", disabled: false},
              {text: "Enterprise Ethernet Physical Modify", value: "Enterprise Ethernet Physical Modify", disabled: false},
              {text: "BTD Redundant Power Supply", value: "BTD Redundant Power Supply", disabled: false},
            ];
            break;
          case "Facilities Access":
            subCategories = [
              {text: "Building Entry Service", value: "Building Entry Service", disabled: false},
              {text: "Co-location Access - Unescorted", value: "Co-location Access - Unescorted", disabled: false},
              {text: "ODF Termination", value: "ODF Termination", disabled: false},
              {text: "Site access required", value: "Site access required", disabled: false},
            ];
            break;
          case "FNN/ULL Dispute":
            break;
          case "NBN Co Service Portal fault":
            subCategories = [
              {text: "NEBS Appointment error", value: "NEBS Appointment error", disabled: false},
              {text: "NEBS Order error", value: "NEBS Order error", disabled: false},
              {text: "NEBS Site Qualification error", value: "NEBS Site Qualification error", disabled: false},
              {text: "NEBS Test & Diagnostics access error", value: "NEBS Test & Diagnostics access error", disabled: false},

              {text: "nbn Live Chat error", value: "nbn Live Chat error", disabled: false},
              {text: "NEBS Service Health error", value: "NEBS Service Health error", disabled: false},
              {text: "NEBS Trouble Ticket error (Service Restoration)", value: "NEBS Trouble Ticket error (Service Restoration)", disabled: false},
              {text: "Other", value: "Other", disabled: false},
            ];
            break;
          case "Orders":
            subCategories = [
              {text: "Appointment", value: "Appointment", disabled: false},
              {text: "Held Order Update", value: "Held Order Update", disabled: false},
              {text: "Order update", value: "Order update", disabled: false},
              {text: "Remote Activation Request", value: "Remote Activation Request", disabled: false},
              {text: "Status Mismatch", value: "Status Mismatch", disabled: false},
              {text: "Order error", value: "Order error", disabled: false}
            ];
            break;
          case "Potential Network Fault Investigation":
            subCategories = [
              {text: "Multiple POI Fibre services", value: "Multiple POI Fibre services", disabled: false},
              {text: "Multiple POI Wireless services", value: "Multiple POI Wireless services", disabled: false},
              {text: "Single POI Fibre services", value: "Single POI Fibre services", disabled: false},
              {text: "Single POI Wireless services", value: "Single POI Wireless services", disabled: false},
              {text: "Single FTTN Service", value: "Single FTTN Service", disabled: false},
              {text: "Multiple FTTN Services", value: "Multiple FTTN Services", disabled: false},
              {text: "Single HFC Service", value: "Single HFC Service", disabled: false},
              {text: "Multiple HFC Services", value: "Multiple HFC Services", disabled: false},
              {text: "Single FTTB service", value: "Single FTTB service", disabled: false},
              {text: "Multiple FTTB services", value: "Multiple FTTB services", disabled: false},
              {text: "Single FTTC service", value: "Single FTTC service", disabled: false},
              {text: "Multiple FTTC services", value: "Multiple FTTC services", disabled: false},
              {text: "NNI/V-NNI", value: "NNI/V-NNI", disabled: false},
              {text: "NEBS Services", value: "NEBS Services", disabled: false},
              {text: "Copper Services", value: "Copper Services", disabled: false}
            ];
            break;
          case "Problem Management Investigation":
            subCategories =
              [
                {text: "Single POI services - Data (Unicast)", value: "Single POI services - Data (Unicast)", disabled: false},
                {text: "Multiple POI services - Data (Unicast)", value: "Multiple POI services - Data (Unicast)", disabled: false},
                {text: "Single POI services - Voice", value: "Single POI services - Voice", disabled: false},
                {text: "Multiple POI services - Voice", value: "Multiple POI services - Voice", disabled: false},
                {text: "Single POI services - Multicast", value: "Single POI services - Multicast", disabled: false},
                {text: "Multiple POI services - Multicast", value: "Multiple POI services - Multicast", disabled: false},
                {text: "Single POI services - All service types", value: "Single POI services - All service types", disabled: false},
                {text: "Multiple POI services - All service types", value: "Multiple POI services - All service types", disabled: false}
              ];
            break;
          case "Reporting Fault":
            subCategories = [
              {text: "Service Health Report (FTTC) fault", value: "Service Health Report (FTTC) fault", disabled: false},
              {text: "Service Health Report (FTTN/B) fault", value: "Service Health Report (FTTN/B) fault", disabled: false}
            ];
            break;
          case "Service Profile":
            subCategories = [
              {text: "Restore DSL Stability Profile", value: "Restore DSL Stability Profile", disabled: false},
            ];
            break;
          case "Service Transfer":
            subCategories = [
              {text: "Service Transfer Update", value: "Service Transfer Update", disabled: false},
              {text: "Connect Outstanding Update", value: "Connect Outstanding Update", disabled: false},
              {text: "Reversal Update", value: "Reversal Update", disabled: false},
              {text: "Held Order Update", value: "Held Order Update", disabled: false},
              {text: "Status Mismatch", value: "Status Mismatch", disabled: false}
            ];
            break;
          case "Technology Enquiry":
            break;
          case "Transition Reversal":
            break;
          case "Voiceband Reinstatement":
            break;
          case "VDSL2 equipment registration":
            subCategories = [
              {text: "New VDSL2 equipment registration", value: "New VDSL2 equipment registration", disabled: false},
              {text: "Re-register VDSL2 equipment", value: "Re-register VDSL2 equipment", disabled: false},
              {text: "Update firmware/hardware", value: "Update firmware/hardware", disabled: false}
            ];
            break;
          case "End User Administration Portal error (EUAP)":
            subCategories = [
              {text: "Modify User", value: "Modify User", disabled: false},
              {text: "Create User", value: "Create User", disabled: false},
              {text: "Suspend User", value: "Suspend User", disabled: false},
              {text: "Modify Profile", value: "Modify Profile", disabled: false},
              {text: "Reset Password", value: "Reset Password", disabled: false}
            ];
            break;
          case "Other":
            subCategories = [
              {text: "General Service Request enquiry", value: "General Service Request enquiry", disabled: false},
            ];
            break;
        }
        return subCategories;
      } else {
        return [];
      }
    },
    States() {
      return [
        {text: "Australian Capital Territory", value: "ACT", disabled: false},
        {text: "New South Wales", value: "NSW", disabled: false},
        {text: "Northern Territory", value: "NT", disabled: false},
        {text: "Queensland", value: "QLD", disabled: false},
        {text: "South Australia", value: "SA", disabled: false},
        {text: "Tasmania", value: "TAS", disabled: false},
        {text: "Victoria", value: "VIC", disabled: false},
        {text: "Western Australia", value: "WA", disabled: false}
      ];
    },
    StreetTypes() {
      return [
        {"text": "Avenue", "value": "AV", "disabled": false},
        {"text": "Drive", "value": "DR", "disabled": false},
        {"text": "Road", "value": "RD", "disabled": false},
        {"text": "Street", "value": "ST", "disabled": false},
        {"text": "Access", "value": "ACCS", "disabled": false},
        {"text": "Acre", "value": "ACRE", "disabled": false},
        {"text": "Alley", "value": "ALLY", "disabled": false},
        {"text": "Alleyway", "value": "ALWY", "disabled": false},
        {"text": "Amble", "value": "AMBL", "disabled": false},
        {"text": "Approach", "value": "APP", "disabled": false},
        {"text": "Arcade", "value": "ARC", "disabled": false},
        {"text": "Arterial", "value": "ARTL", "disabled": false},
        {"text": "Artery", "value": "ARTY", "disabled": false},
        {"text": "Awlk", "value": "AIRWALK", "disabled": false},
        {"text": "Banan", "value": "BA", "disabled": false},
        {"text": "Bank", "value": "BANK", "disabled": false},
        {"text": "Bay", "value": "BAY", "disabled": false},
        {"text": "Beach", "value": "BCH", "disabled": false},
        {"text": "Bend", "value": "BEND", "disabled": false},
        {"text": "Boardwalk", "value": "BWLK", "disabled": false},
        {"text": "Boulevard", "value": "BVD", "disabled": false},
        {"text": "Boulevarde", "value": "BVDE", "disabled": false},
        {"text": "Bowl", "value": "BOWL", "disabled": false},
        {"text": "Brace", "value": "BR", "disabled": false},
        {"text": "Brae", "value": "BRAE", "disabled": false},
        {"text": "Branch", "value": "BRAN", "disabled": false},
        {"text": "Break", "value": "BRK", "disabled": false},
        {"text": "Brett", "value": "BRET", "disabled": false},
        {"text": "Bridge", "value": "BDGE", "disabled": false},
        {"text": "Broadwalk", "value": "BRDWLK", "disabled": false},
        {"text": "Broadway", "value": "BDWY", "disabled": false},
        {"text": "Brow", "value": "BROW", "disabled": false},
        {"text": "Bull", "value": "BULL", "disabled": false},
        {"text": "Busway", "value": "BSWY", "disabled": false},
        {"text": "Bypass", "value": "BYPA", "disabled": false},
        {"text": "Byway", "value": "BYWY", "disabled": false},
        {"text": "Causeway", "value": "CSWY", "disabled": false},
        {"text": "Centre", "value": "CTR", "disabled": false},
        {"text": "Centreway", "value": "CNWY", "disabled": false},
        {"text": "Chase", "value": "CH", "disabled": false},
        {"text": "Circle", "value": "CIR", "disabled": false},
        {"text": "Circlet", "value": "CLT", "disabled": false},
        {"text": "Circuit", "value": "CCT", "disabled": false},
        {"text": "Circus", "value": "CRCS", "disabled": false},
        {"text": "Close", "value": "CL", "disabled": false},
        {"text": "Cluster", "value": "CLR", "disabled": false},
        {"text": "Colonnade", "value": "CLDE", "disabled": false},
        {"text": "Common", "value": "CMMN", "disabled": false},
        {"text": "Commons", "value": "CMMNS", "disabled": false},
        {"text": "Concord", "value": "CNCD", "disabled": false},
        {"text": "Concourse", "value": "CON", "disabled": false},
        {"text": "Connection", "value": "CNTN", "disabled": false},
        {"text": "Copse", "value": "CPS", "disabled": false},
        {"text": "Corner", "value": "CNR", "disabled": false},
        {"text": "Corso", "value": "CSO", "disabled": false},
        {"text": "Course", "value": "CRSE", "disabled": false},
        {"text": "Court", "value": "CT", "disabled": false},
        {"text": "Courtyard", "value": "CTYD", "disabled": false},
        {"text": "Cove", "value": "COVE", "disabled": false},
        {"text": "Crescent", "value": "CR", "disabled": false},
        {"text": "Crest", "value": "CRST", "disabled": false},
        {"text": "Crief", "value": "CRF", "disabled": false},
        {"text": "Crook", "value": "CRK", "disabled": false},
        {"text": "Cross", "value": "CRSS", "disabled": false},
        {"text": "Crossing", "value": "CRSG", "disabled": false},
        {"text": "Cruiseway", "value": "CUWY", "disabled": false},
        {"text": "Cul-De-Sac", "value": "CSAC", "disabled": false},
        {"text": "Cut", "value": "CUT", "disabled": false},
        {"text": "Cutting", "value": "CUTT", "disabled": false},
        {"text": "Dale", "value": "DALE", "disabled": false},
        {"text": "Dash", "value": "DASH", "disabled": false},
        {"text": "Dell", "value": "DELL", "disabled": false},
        {"text": "Dene", "value": "DENE", "disabled": false},
        {"text": "Deviation", "value": "DE", "disabled": false},
        {"text": "Dip", "value": "DIP", "disabled": false},
        {"text": "Distributor", "value": "DSTR", "disabled": false},
        {"text": "Divide", "value": "DIV", "disabled": false},
        {"text": "Dock", "value": "DOCK", "disabled": false},
        {"text": "Domain", "value": "DOM", "disabled": false},
        {"text": "Down", "value": "DOWN", "disabled": false},
        {"text": "Downs", "value": "DWNS", "disabled": false},
        {"text": "Driveway", "value": "DVWY", "disabled": false},
        {"text": "Easement", "value": "ESMT", "disabled": false},
        {"text": "East", "value": "EAST", "disabled": false},
        {"text": "Edge", "value": "EDGE", "disabled": false},
        {"text": "Elbow", "value": "ELB", "disabled": false},
        {"text": "End", "value": "END", "disabled": false},
        {"text": "Entrance", "value": "ENT", "disabled": false},
        {"text": "Esplanade", "value": "ESP", "disabled": false},
        {"text": "Estate", "value": "EST", "disabled": false},
        {"text": "Expressway", "value": "EXP", "disabled": false},
        {"text": "Extension", "value": "EXTN", "disabled": false},
        {"text": "Fairway", "value": "FAWY", "disabled": false},
        {"text": "Firebreak", "value": "FBRK", "disabled": false},
        {"text": "Fireline", "value": "FLNE", "disabled": false},
        {"text": "Firetrack", "value": "FTRK", "disabled": false},
        {"text": "Firetrail", "value": "FITR", "disabled": false},
        {"text": "Flat", "value": "FLAT", "disabled": false},
        {"text": "Flats", "value": "FLTS", "disabled": false},
        {"text": "Follow", "value": "FOLW", "disabled": false},
        {"text": "Footway", "value": "FTWY", "disabled": false},
        {"text": "Ford", "value": "FORD", "disabled": false},
        {"text": "Foreshore", "value": "FSHR", "disabled": false},
        {"text": "Fork", "value": "FORK", "disabled": false},
        {"text": "Formation", "value": "FORM", "disabled": false},
        {"text": "Freeway", "value": "FWY", "disabled": false},
        {"text": "Front", "value": "FRNT", "disabled": false},
        {"text": "Frontage", "value": "FRTG", "disabled": false},
        {"text": "Gap", "value": "GAP", "disabled": false},
        {"text": "Garden", "value": "GDN", "disabled": false},
        {"text": "Gardens", "value": "GDNS", "disabled": false},
        {"text": "Gate", "value": "GTE", "disabled": false},
        {"text": "Gateway", "value": "GWY", "disabled": false},
        {"text": "Glade", "value": "GLDE", "disabled": false},
        {"text": "Glen", "value": "GLEN", "disabled": false},
        {"text": "Grange", "value": "GRA", "disabled": false},
        {"text": "Green", "value": "GRN", "disabled": false},
        {"text": "Grove", "value": "GR", "disabled": false},
        {"text": "Gully", "value": "GLY", "disabled": false},
        {"text": "Harbour", "value": "HRBR", "disabled": false},
        {"text": "Haven", "value": "HVN", "disabled": false},
        {"text": "Heath", "value": "HTH", "disabled": false},
        {"text": "Heights", "value": "HTS", "disabled": false},
        {"text": "Highroad", "value": "HIRD", "disabled": false},
        {"text": "Highway", "value": "HWY", "disabled": false},
        {"text": "Hike", "value": "HIKE", "disabled": false},
        {"text": "Hill", "value": "HILL", "disabled": false},
        {"text": "Hills", "value": "HILLS", "disabled": false},
        {"text": "Hollow", "value": "HLLW", "disabled": false},
        {"text": "Hub", "value": "HUB", "disabled": false},
        {"text": "Inlet", "value": "INLT", "disabled": false},
        {"text": "Interchange", "value": "INTG", "disabled": false},
        {"text": "Island", "value": "ID", "disabled": false},
        {"text": "Junction", "value": "JNC", "disabled": false},
        {"text": "Key", "value": "KEY", "disabled": false},
        {"text": "Keys", "value": "KEYS", "disabled": false},
        {"text": "Knoll", "value": "KNOL", "disabled": false},
        {"text": "Ladder", "value": "LADR", "disabled": false},
        {"text": "Landing", "value": "LDG", "disabled": false},
        {"text": "Lane", "value": "LANE", "disabled": false},
        {"text": "Laneway", "value": "LNWY", "disabled": false},
        {"text": "Lead", "value": "LEAD", "disabled": false},
        {"text": "Leader", "value": "LEDR", "disabled": false},
        {"text": "Line", "value": "LINE", "disabled": false},
        {"text": "Link", "value": "LINK", "disabled": false},
        {"text": "Lookout", "value": "LKT", "disabled": false},
        {"text": "Loop", "value": "LOOP", "disabled": false},
        {"text": "Lynne", "value": "LYNN", "disabled": false},
        {"text": "Mall", "value": "MALL", "disabled": false},
        {"text": "Manor", "value": "MANR", "disabled": false},
        {"text": "Mart", "value": "MART", "disabled": false},
        {"text": "Maze", "value": "MZ", "disabled": false},
        {"text": "Mead", "value": "MEAD", "disabled": false},
        {"text": "Meander", "value": "MNDR", "disabled": false},
        {"text": "Mew", "value": "MEW", "disabled": false},
        {"text": "Mews", "value": "MEWS", "disabled": false},
        {"text": "Mile", "value": "MILE", "disabled": false},
        {"text": "Motorway", "value": "MTWY", "disabled": false},
        {"text": "Nook", "value": "NOOK", "disabled": false},
        {"text": "North", "value": "NTH", "disabled": false},
        {"text": "Null", "value": "NULL", "disabled": false},
        {"text": "Outlet", "value": "OTLT", "disabled": false},
        {"text": "Outlook", "value": "OTLK", "disabled": false},
        {"text": "Oval", "value": "OVAL", "disabled": false},
        {"text": "Palms", "value": "PLMS", "disabled": false},
        {"text": "Parade", "value": "PDE", "disabled": false},
        {"text": "Paradise", "value": "PRDS", "disabled": false},
        {"text": "Park", "value": "PARK", "disabled": false},
        {"text": "Parkway", "value": "PWY", "disabled": false},
        {"text": "Part", "value": "PART", "disabled": false},
        {"text": "Pass", "value": "PASS", "disabled": false},
        {"text": "Passage", "value": "PSGE", "disabled": false},
        {"text": "Path", "value": "PATH", "disabled": false},
        {"text": "Pathway", "value": "PWAY", "disabled": false},
        {"text": "Peninsula", "value": "PSLA", "disabled": false},
        {"text": "Piazza", "value": "PIAZ", "disabled": false},
        {"text": "Place", "value": "PL", "disabled": false},
        {"text": "Plaza", "value": "PLZA", "disabled": false},
        {"text": "Pocket", "value": "PKT", "disabled": false},
        {"text": "Point", "value": "PNT", "disabled": false},
        {"text": "Port", "value": "PORT", "disabled": false},
        {"text": "Precinct", "value": "PREC", "disabled": false},
        {"text": "Promenade", "value": "PROM", "disabled": false},
        {"text": "Pursuit", "value": "PRST", "disabled": false},
        {"text": "Quad", "value": "QUAD", "disabled": false},
        {"text": "Quadrant", "value": "QDRT", "disabled": false},
        {"text": "Quay", "value": "QY", "disabled": false},
        {"text": "Quays", "value": "QYS", "disabled": false},
        {"text": "Ramble", "value": "RMBL", "disabled": false},
        {"text": "Ramp", "value": "RAMP", "disabled": false},
        {"text": "Range", "value": "RNGE", "disabled": false},
        {"text": "Reach", "value": "RCH", "disabled": false},
        {"text": "Reef", "value": "REEF", "disabled": false},
        {"text": "Reserve", "value": "RES", "disabled": false},
        {"text": "Rest", "value": "REST", "disabled": false},
        {"text": "Retreat", "value": "RTT", "disabled": false},
        {"text": "Return", "value": "RTN", "disabled": false},
        {"text": "Ride", "value": "RIDE", "disabled": false},
        {"text": "Ridge", "value": "RDGE", "disabled": false},
        {"text": "Right Of Way", "value": "ROFW", "disabled": false},
        {"text": "Ring", "value": "RING", "disabled": false},
        {"text": "Rise", "value": "RISE", "disabled": false},
        {"text": "Rising", "value": "RSNG", "disabled": false},
        {"text": "River", "value": "RVR", "disabled": false},
        {"text": "Roads", "value": "RDS", "disabled": false},
        {"text": "Roadway", "value": "RDWY", "disabled": false},
        {"text": "Rotary", "value": "RTY", "disabled": false},
        {"text": "Round", "value": "RND", "disabled": false},
        {"text": "Route", "value": "RTE", "disabled": false},
        {"text": "Row", "value": "ROW", "disabled": false},
        {"text": "Rowe", "value": "ROWE", "disabled": false},
        {"text": "Rue", "value": "RUE", "disabled": false},
        {"text": "Run", "value": "RUN", "disabled": false},
        {"text": "Serviceway", "value": "SVWY", "disabled": false},
        {"text": "Shunt", "value": "SHUN", "disabled": false},
        {"text": "Skyline", "value": "SKLN", "disabled": false},
        {"text": "Slope", "value": "SLPE", "disabled": false},
        {"text": "South", "value": "STH", "disabled": false},
        {"text": "Spur", "value": "SPUR", "disabled": false},
        {"text": "Square", "value": "SQ", "disabled": false},
        {"text": "Steps", "value": "STPS", "disabled": false},
        {"text": "Straight", "value": "STRT", "disabled": false},
        {"text": "Strait", "value": "STAI", "disabled": false},
        {"text": "Strand", "value": "STRA", "disabled": false},
        {"text": "Strip", "value": "STRP", "disabled": false},
        {"text": "Subway", "value": "SBWY", "disabled": false},
        {"text": "Tarn", "value": "TARN", "disabled": false},
        {"text": "Terrace", "value": "TCE", "disabled": false},
        {"text": "Thoroughfare", "value": "THFR", "disabled": false},
        {"text": "Throughway", "value": "THRU", "disabled": false},
        {"text": "Tollway", "value": "TLWY", "disabled": false},
        {"text": "Top", "value": "TOP", "disabled": false},
        {"text": "Tor", "value": "TOR", "disabled": false},
        {"text": "Track", "value": "TRK", "disabled": false},
        {"text": "Trail", "value": "TRL", "disabled": false},
        {"text": "Tramway", "value": "TMWY", "disabled": false},
        {"text": "Traverse", "value": "TVSE", "disabled": false},
        {"text": "Trunkway", "value": "TKWY", "disabled": false},
        {"text": "Tunnel", "value": "TUNL", "disabled": false},
        {"text": "Turn", "value": "TURN", "disabled": false},
        {"text": "Twist", "value": "TWIST", "disabled": false},
        {"text": "Underpass", "value": "UPAS", "disabled": false},
        {"text": "Vale", "value": "VALE", "disabled": false},
        {"text": "Valley", "value": "VLLY", "disabled": false},
        {"text": "Verge", "value": "VERGE", "disabled": false},
        {"text": "Viaduct", "value": "VIAD", "disabled": false},
        {"text": "View", "value": "VIEW", "disabled": false},
        {"text": "Views", "value": "VWS", "disabled": false},
        {"text": "Villa", "value": "VLLA", "disabled": false},
        {"text": "Village", "value": "VLGE", "disabled": false},
        {"text": "Villas", "value": "VLLS", "disabled": false},
        {"text": "Vista", "value": "VSTA", "disabled": false},
        {"text": "Vue", "value": "VUE", "disabled": false},
        {"text": "Wade", "value": "WADE", "disabled": false},
        {"text": "Walk", "value": "WALK", "disabled": false},
        {"text": "Walkway", "value": "WKWY", "disabled": false},
        {"text": "Waters", "value": "WTRS", "disabled": false},
        {"text": "Waterway", "value": "WTWY", "disabled": false},
        {"text": "Way", "value": "WAY", "disabled": false},
        {"text": "West", "value": "WEST", "disabled": false},
        {"text": "Wharf", "value": "WHRF", "disabled": false},
        {"text": "Wood", "value": "WD", "disabled": false},
        {"text": "Woods", "value": "WDS", "disabled": false},
        {"text": "Wynd", "value": "WYND", "disabled": false},
        {"text": "Yard", "value": "YARD", "disabled": false}]
    }
  }
}
</script>

<style scoped>

</style>
